var v = Object.defineProperty, g = Object.defineProperties;
var m = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var u = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
var w = (r, e, n) => e in r ? v(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n, t = (r, e) => {
  for (var n in e || (e = {}))
    u.call(e, n) && w(r, n, e[n]);
  if (l)
    for (var n of l(e))
      a.call(e, n) && w(r, n, e[n]);
  return r;
}, d = (r, e) => g(r, m(e));
var h = (r, e) => {
  var n = {};
  for (var o in r)
    u.call(r, o) && e.indexOf(o) < 0 && (n[o] = r[o]);
  if (r != null && l)
    for (var o of l(r))
      e.indexOf(o) < 0 && a.call(r, o) && (n[o] = r[o]);
  return n;
};
import { jsx as i } from "react/jsx-runtime";
import { r as f } from "./rem-CMQJ_ZTp.js";
import "react";
function p(o) {
  var c = o, { size: r, style: e } = c, n = h(c, ["size", "style"]);
  const s = r !== void 0 ? t({ width: f(r), height: f(r) }, e) : e;
  return /* @__PURE__ */ i(
    "svg",
    d(t({
      viewBox: "0 0 10 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: s,
      "aria-hidden": !0
    }, n), {
      children: /* @__PURE__ */ i(
        "path",
        {
          d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    })
  );
}
function B(n) {
  var o = n, { indeterminate: r } = o, e = h(o, ["indeterminate"]);
  return r ? /* @__PURE__ */ i(
    "svg",
    d(t({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 6",
      "aria-hidden": !0
    }, e), {
      children: /* @__PURE__ */ i("rect", { width: "32", height: "6", fill: "currentColor", rx: "3" })
    })
  ) : /* @__PURE__ */ i(p, t({}, e));
}
export {
  p as C,
  B as a
};
